const {
  formatMoney,
  isANumber,
  parseInteger,
  buildProperties,
} = window.BAO.Utils

class ProductBundleDrawer extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['variant', 'button']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleFormSubmission = this.handleFormSubmission.bind(this)
    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)

    if (this.els?.button?.exists && this.els?.form?.exists) {
      this.listeners.add(
        this.els.button.element,
        'click',
        this.handleFormSubmission,
      )
    }

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.onQuantityUpdate,
    )
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onQuantityUpdate (event) {
    const variantEl = event.target.closest(this.els?.variant?.selector)
    if (!isANumber(event?.detail?.value) || !variantEl) return

    variantEl.setAttribute('data-quantity', String(event.detail.value))

    this.els.button.element.setAttribute('aria-invalid', 'false')
    this.calculateTotalQuantity()
    this.calculateSubtotal()
    this.updateButtonText()
  }

  /**
   * @returns {void}
   */
  handleFormSubmission () {
    this.calculateTotalQuantity()

    const isValid = this.totalQuantity > 0
    this.els.button.element.setAttribute('aria-invalid', String(!isValid))

    if (!isValid) return

    const itemsArray = this.els.form.elements
      .map(formEl => {
        const formData = new FormData(formEl)
        const id = parseInteger(formData.get('id'))
        const quantity = parseInteger(formData.get('quantity'))
        if (!id || !quantity) return null
        return {
          id,
          quantity,
          properties: buildProperties(formData),
        }
      })
      .filter(item => item)
    window.BAO.Cart.addItem(itemsArray)
  }

  calculateTotalQuantity () {
    this.totalQuantity = this.els.variant.elements
      .map(variantEl => {
        return parseInteger(variantEl?.dataset?.quantity)
      })
      .reduce((previousValue, currentValue) => {
        return previousValue + currentValue
      })
  }

  calculateSubtotal () {
    this.subtotal = this.els.variant.elements
      .map(variantEl => {
        return (
          parseInteger(variantEl?.dataset?.price) *
          parseInteger(variantEl?.dataset?.quantity)
        )
      })
      .reduce((previousValue, currentValue) => {
        return previousValue + currentValue
      })
  }

  updateButtonText () {
    const buttonText = this.els.button.element.textContent.split('(')[0]

    if (this.subtotal > 0) {
      this.els.button.element.textContent = `${buttonText} (${formatMoney(
        this.subtotal,
      )})`
    } else {
      this.els.button.element.textContent = buttonText
    }
  }

  /**
   * @returns {number} quantity - The current running total quantity selected with the associated quantity-adjusters
   */
  get totalQuantity () {
    return this._totalQuantity || 0
  }

  /**
   * @param {number} quantity - The current running total quantity selected with the associated quantity-adjusters
   *
   * @returns {undefined}
   */
  set totalQuantity (quantity) {
    this._totalQuantity = quantity
  }

  /**
   * @returns {number} subtotal - The current running subotal
   */
  get subtotal () {
    return this._subtotal || 0
  }

  /**
   * @param {number} subtotal - The current running subotal
   *
   * @returns {undefined}
   */
  set subtotal (subtotal) {
    this._subtotal = subtotal
    if (this.els.subtotal?.exists) {
      this.els.subtotal.element.textContent = `(${formatMoney(subtotal)})`
      this.els.subtotal.element.setAttribute(
        'aria-hidden',
        String(subtotal < 1),
      )
    }
  }
}

if (!customElements.get('product-bundle-drawer')) {
  customElements.define('product-bundle-drawer', ProductBundleDrawer)
}
